export default "__VITE_PUBLIC_ASSET__6771aa23__"